import { render, staticRenderFns } from "./evento.vue?vue&type=template&id=2aa22116&scoped=true"
import script from "./evento.vue?vue&type=script&lang=js"
export * from "./evento.vue?vue&type=script&lang=js"
import style0 from "./evento.vue?vue&type=style&index=0&id=2aa22116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa22116",
  null
  
)

export default component.exports